export default __webpack_public_path__ + "static/media/everything.cd5218d0.gif";